import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './Goals.module.css';

const Goals = ({ targetBodyWeight }) => {
  if (targetBodyWeight == null || targetBodyWeight === '') {
    return (
      <div className={styles.Goals}>
        <h3 className={styles.Title}>Current Goals</h3>
        <p className={styles.Empty}>
          Set your target body weight on{' '}
          <Link to="/statistics" className={styles.EmptyLink}>My Progress</Link>{' '}
          to see your daily protein goal.
        </p>
      </div>
    );
  }

  const proteinGoal = Math.round(Number(targetBodyWeight));

  return (
    <div className={styles.Goals}>
      <h3 className={styles.Title}>Current Goals</h3>
      <div className={styles.GoalRow}>
        <div>
          <p className={styles.GoalName}>Daily Protein</p>
          <p className={styles.GoalDetail}>
            1g per lb of target body weight ({targetBodyWeight} lb)
          </p>
        </div>
        <p className={styles.GoalValue}>{proteinGoal}g</p>
      </div>
    </div>
  );
};

const mapStateToProps = reduxState => ({
  targetBodyWeight: reduxState.user.targetBodyWeight,
});

export default connect(mapStateToProps)(Goals);
